export {
  axisTop,
  axisRight,
  axisBottom,
  axisLeft
} from "./src/axis";



//////////////////
// WEBPACK FOOTER
// ./~/d3-axis/index.js
// module id = 787
// module chunks = 0